module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgBAMAAAAQtmoLAAAAIVBMVEUAAACysrK1tbWysrKysrK0tLSysrKzs7O2tra0tLSysrKiK23eAAAACnRSTlMA8Tbin4RxLw5twPRm/gAAAOJJREFUWMPtljsKAkEQRMVI0w2NFG9g5AkMvIBgbGRuYiR4Aa8g+IE6pYEstctCV0ln0hU283j7memeUaVSqVR+zGlz6Rcmh120fgqs+pUlcAuAM3CfdwvjGfAOgD2ApltYAHgGwBatggI8AuCIVkEBXgFwRaugAOsA+K5oKCA/yHAJcVNB2lMQNhVkPQVRU0HSVFBgKigwFRSYCgpMBQW2ggKtoMBVUJAE9CPlX1p/1vyP01sjv/n09s4fIH1E801At5l8I9OtMt+MdbvPDxQ9svyhmB+7erD7V4dKpVL5r3wAz8H1C8h7jEMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/moment/greet_icon_close.png
// module id = qHAW
// module chunks = 36